import axios from 'axios';
import moment from 'moment';

export const currentDate = moment(new Date()).format('YYYY-MM-DD');

export const getFilteredFields = (allFields, notRequiredFields) => {
  return allFields.filter(item => !notRequiredFields.includes(item));
};

export const validateEmail = (email) => {
  const regexp = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  return regexp.test(email.trim());
};

export const validatePassword = (password) => {
  const regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d@$!%*?&#]{8,}$/;
  return regexp.test(password.trim());
};

export const fetchSelectOptions = async (url, type) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/${url}?type=${type}`);
    return response.data.result;
  } catch (error) {
    console.error('Error fetching select options:', error);
    return [];
  }
};

export const validateFile = (file, allowedTypes, maxSize) => {
  if (file.size > maxSize) {
    alert(`Please upload files up to ${maxSize / (1024 * 1024)} MB.`);
    return false;
  }
  return true;
};

